export const config = {
  auth: {
    user_pool_id: import.meta.env.VITE_USER_POOL_ID,
    aws_region: import.meta.env.VITE_AWS_REGION,
    user_pool_client_id: import.meta.env.VITE_USER_POOL_CLIENT_ID,
    standard_required_attributes: ["email"],
    username_attributes: ["email"],
    user_verification_types: ["email"],
    password_policy: {
      min_length: 8,
      require_numbers: true,
      require_lowercase: true,
      require_uppercase: true,
      require_symbols: true,
    },
    oauth: {
      identity_providers: ["GOOGLE"],
      redirect_sign_in_uri: [
        import.meta.env.VITE_URL_COGNITO_LOGIN,
        "http://localhost:3000",
      ],
      redirect_sign_out_uri: [
        import.meta.env.VITE_URL_COGNITO_LOGOUT,
        "http://localhost:3000",
      ],
      response_type: "code",
      scopes: ["phone", "email", "openid", "aws.cognito.signin.user.admin"],
      domain: import.meta.env.VITE_URL_COGNITO_DOMAIN,
    },
    unauthenticated_identities_enabled: true,
  },
  version: "1",
};
